module.exports = __webpack_public_path__ + "img/logo.f83f2645.png";